<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :batch-actions="batchActions"
    :form="form"
    :title="$t('model.reports/commission_source')"
    namespace=""
    resource="reports/commission_sources"
    :action-buttons="[]"
  >
    <template #action>
      <DialogLoading
        :visible="exportLoading"
        description="正在生成导出文件，预计需要 1-3 分钟，请等待"
        :title="`导出处理中`"
      />
      <el-button type="primary" @click="handleExport">导出汇总</el-button>
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import DialogContent from '@/components/dialog-content';
import Orders from './orders';
import DialogLoading from '@/components/dialog-loading';
import { exportFile } from '@/utils/export';
import { OrderStatus } from '@/constants';
import _ from 'lodash';
import { columnKeyByProp as shareFilterColumnKeyByProp } from './share-filter-columns';

@Component({
  components: {
    DialogLoading
  }
})
export default class CommissionSources extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}
  exportLoading = false;

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'id_eq',
        label: '业务员',
        renderCell: {
          component: 'app-read-options',
          props: {
            clearable: true,
            url: 'users/read_options',
            params: this.userOptionsFilter,
            labelField: 'screen_name',
            valueField: 'id',
          }
        }
      },
      {
        prop: 'jushuitan_orders_shop_id_eq',
        label: '店铺',
        renderCell: {
          component: 'app-read-options',
          props: {
            clearable: true,
            url: 'jushuitan_shops/read_options',
            params: { per_page: 100 },
            labelField: 'shop_name',
            valueField: 'shop_id',
            idInField: 'shop_id_in',
          }
        }
      },
      shareFilterColumnKeyByProp['ordered_on_gteq_in_sales_orders'],
      shareFilterColumnKeyByProp['ordered_on_lteq_in_sales_orders'],
      shareFilterColumnKeyByProp['product_type_eq_in_sales_orders'],
      // TODO: api缺筛选
      // {
      //   prop: '',
      //   label: '快递公司',
      // },
      {
        prop: 'jushuitan_orders_customer_id_eq',
        label: '客户',
        renderCell: {
          component: 'app-read-options',
          props: {
            clearable: true,
            url: 'customers/read_options',
            params: this.customerOptionsFilter,
            labelField: 'name',
            valueField: 'id',
          }
        }
      },
      {
        prop: 'jushuitan_orders_status_in',
        label: '状态',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            multiple: true,
            options: _.map(OrderStatus, (key, value) => ({ label: key, value }))
          }
        }
      },
      shareFilterColumnKeyByProp['kind_eq_in_sales_orders'],
      {
        prop: 'jushuitan_orders_sent_at_gteq_date',
        label: '发货开始日期',
        renderCell: {
          component: 'datePicker',
          props: {
            valueFormat: 'yyyy-MM-dd'
          }
        }
      },
      {
        prop: 'jushuitan_orders_sent_at_lteq_date',
        label: '发货结束日期',
        renderCell: {
          component: 'datePicker',
          props: {
            valueFormat: 'yyyy-MM-dd'
          }
        }
      },
      shareFilterColumnKeyByProp['finished_on_month_eq_in_sales_orders'],
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  scopeColumns() {
    return [];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      {
        prop: 'screen_name',
        label: '业务员',
        width: 140,
      },
      {
        prop: 'receivable_amount',
        label: '销售总金额',
        minWidth: 140,
        renderCell: 'app-locale-string',
        // TODO: api还不支持
        sortable: true
      },
      {
        prop: 'after_sale_sales_order_amount',
        label: '退款总金额',
        minWidth: 140,
        renderCell: 'app-locale-string'
      },
      {
        prop: 'received_amount',
        label: '已收总金额',
        minWidth: 140,
        renderCell: 'app-locale-string'
      },
      // {
      //   prop: 'receivable_amount',
      //   label: '应收总金额',
      //   minWidth: 140,
      //   renderCell: 'app-locale-string'
      // },
      // TODO: 缺字段
      {
        prop: 'tax',
        label: '税费总计',
        minWidth: 140,
        renderCell: 'app-locale-string'
      },
      {
        prop: 'freight',
        label: '总运费',
        minWidth: 140,
        renderCell: 'app-locale-string'
      },
      {
        prop: 'cost',
        label: '总成本',
        minWidth: 140,
        renderCell: 'app-locale-string'
      },
      {
        prop: 'profit',
        label: '总利润',
        minWidth: 140,
        renderCell: 'app-locale-string'
      },
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        prop: 'id',
        label: '编号',
        renderCell: {
          component: 'input',
          required: true
        }
      }
    ];
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }) {
    return [
      // {
      //   component: 'routeButton',
      //   props: {
      //     label: '编辑',
      //     to: { name: 'commission_sources.edit', params: { id: row.id } }
      //   }
      // },
      // {
      //   component: 'confirmButton',
      //   props: {
      //     label: '删除',
      //     type: 'danger',
      //     can: 'commission_sources.destroy'
      //   },
      //   on: {
      //     confirm: () => remove(row.id)
      //   }
      // }
      {
        component: () => {
          return (
            <DialogContent reRenderWhenOpen fullScreen title={`订单 - ${row.screen_name}`} triggerText="查看订单" disabled={row.sales_order_amount <= 0}>
              <Orders
                commissionSourceId={row.id}
                initParams={_.pick(this.$route.query, [
                  'product_type_eq_in_sales_orders',
                  'kind_eq_in_sales_orders',
                  'ordered_on_gteq_in_sales_orders',
                  'ordered_on_lteq_in_sales_orders',
                  'finished_on_month_eq_in_sales_orders'
                ])}
              />
            </DialogContent>
          )
        }
      }
    ].filter(Boolean);
  }

  /**
   * @param {Object} scope -表格 scope 数据
   * @param {Object} scope.selection - 表格已选择行数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  batchActions() {
  // batchActions({ selection }, { remove, reload }) {
    return [
      // () => <el-button onClick={() => console.log(selection)}>批处理({ selection.length })</el-button>
    ];
  }

  async handleExport() {
    this.exportLoading = true;
    try {
      await exportFile('reports/commission_sources/summary_xlsx', _.omit(this.$route.query, ['page', 'per_page']));
    } finally {
      this.exportLoading = false;
    }
  }

}


export const route = [
  {
    path: '/reports/commission_sources',
    name: 'reports/commission_sources.index',
    component: CommissionSources,
    props: {
      type: 'index',
    },
    meta: {
      can: 'reports/commission_sources.read'
    }
  },
  {
    path: '/reports/commission_sources/new',
    name: 'reports/commission_sources.new',
    component: CommissionSources,
    props: {
      type: 'new',
    },
    meta: {
      can: 'reports/commission_sources.create'
    }
  },
  {
    path: '/reports/commission_sources/:id',
    name: 'reports/commission_sources.show',
    component: CommissionSources,
    props: {
      type: 'show',
    },
    meta: {
      can: 'reports/commission_sources.read'
    }
  },
  {
    path: '/reports/commission_sources/:id/edit',
    name: 'reports/commission_sources.edit',
    component: CommissionSources,
    props: {
      type: 'edit'
    },
    meta: {
      can: 'reports/commission_sources.update'
    }
  }
]
</script>
